import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  CreateLinkedEasyPvProjectMutation as _CreateLinkedEasyPvProjectMutation,
  CreateLinkedEasyPvProjectInput,
} from '@/gql/graphql';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const CreateLinkedEasyPVProjectMutation = graphql(`
  mutation CreateLinkedEasyPVProject($input: CreateLinkedEasyPVProjectInput!) {
    createLinkedEasyPVProject(input: $input) {
      __typename
      ... on CreateLinkedProjectError {
        code
        message
      }
    }
  }
`);

const useCreateLinkedEasyPVProject = (
  options?: UseMutationOptions<
    _CreateLinkedEasyPvProjectMutation,
    unknown,
    CreateLinkedEasyPvProjectInput
  >
) => {
  return useMutation({
    mutationFn: (input: CreateLinkedEasyPvProjectInput) => {
      return gqlClient.request(CreateLinkedEasyPVProjectMutation, {
        input,
      });
    },
    ...options,
  });
};

export default useCreateLinkedEasyPVProject;
